import { compose, setDisplayName, withHandlers } from 'recompose';
import { connect } from 'formik';

export const enhance = compose(
  setDisplayName('SegmentedEnhanced'),
  connect,
  withHandlers({
    handleClick:
      ({ disabled, formik: { setFieldValue }, name }) =>
      (item) =>
      () =>
        disabled ? null : setFieldValue(name, item.value),
  })
);
